import * as Yup from 'yup';

const businessUnitValidation = Yup.object({
  tradingName: Yup.string().nullable().required('Please enter a division name.')
});

export default businessUnitValidation;
